export default __webpack_public_path__ + "static/Witcher-651031430957087d15893753facf380f.png";